module.exports = __webpack_public_path__ + "img/9788983947079.7fd119a9.jpg";